module.exports = __webpack_public_path__ + "static/media/share.88b7c160.svg";